/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mining.vue?vue&type=template&id=8230cc56&scoped=true"
import script from "./mining.vue?vue&type=script&lang=js"
export * from "./mining.vue?vue&type=script&lang=js"
import style0 from "./mining.vue?vue&type=style&index=0&id=8230cc56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8230cc56",
  null
  
)

export default component.exports